export function parseProjectMmCode(mmCode: string | number | undefined): number | null {
  if (mmCode === undefined || mmCode === null || mmCode === "") return null;
  const parsed = typeof mmCode === "number" ? mmCode : Number(mmCode);
  return Number.isFinite(parsed) ? parsed : null;
}
